export default __webpack_public_path__ + "static/media/qbo.e1d152a5.png";